import { ThemeProvider } from "@emotion/react";
import { noop } from "lodash";
import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { Grid, ViewContainer, ViewStack } from "components/grid";
import { SideNavigation } from "components/side-navigation";
import { newFeaturesCampaigns } from "constants/campaigns";
import { isInIframe } from "helpers/app";
import { useNewFeatureForAgents } from "hooks/use-new-feature-for-agents";
import { withRememberLastRoute } from "routes/withRememberLastRoute";
import { selectFeatureToggleMacros } from "store/entities/license";
import { legacyTheme } from "themes/legacyTheme";

import { AutomationsRouter } from "./AutomationsRouter";
import { AutomationsRoutes } from "./constants";
import { automationsNavigationItems } from "./navigationItems";

const Automations: FC = () => {
  const featureToggleMacros = useSelector(selectFeatureToggleMacros);
  const location = useLocation();
  const { isNewForAgent: areMacrosNewForAgent, featureFlagValue: macrosSectionsSeen } = useNewFeatureForAgents(
    newFeaturesCampaigns.hasSeenMacrosSection.flag,
    newFeaturesCampaigns.hasSeenMacrosSection.campaignStartDate
  );
  const { setAgentFlagCallback: markAutomationsAsOpened } = useNewFeatureForAgents(
    newFeaturesCampaigns.hasOpenedAutomationsAfterMacrosRelease.flag,
    newFeaturesCampaigns.hasOpenedAutomationsAfterMacrosRelease.campaignStartDate
  );

  const sidebarHidden =
    [
      `${AutomationsRoutes.AddRule}`,
      `${AutomationsRoutes.EditRule}`,
      `${AutomationsRoutes.AddMacro}`,
      `${AutomationsRoutes.EditMacro}`,
    ].some(path => location.pathname.startsWith(path)) || isInIframe();

  if (!featureToggleMacros) {
    return (
      <ThemeProvider theme={legacyTheme}>
        <AutomationsRouter />
      </ThemeProvider>
    );
  }

  useEffect((): void => markAutomationsAsOpened(), []);

  return (
    <ThemeProvider theme={legacyTheme}>
      <Grid
        relativeWidths={sidebarHidden ? [1] : [1, 10]}
        minWidths={sidebarHidden ? [0, 0] : [280, 0]}
        noBorder={isInIframe()}
      >
        {!sidebarHidden && (
          <ViewStack>
            <ViewContainer title="Automations">
              <SideNavigation
                activeItemId={AutomationsRoutes.Rules}
                items={automationsNavigationItems(!macrosSectionsSeen && areMacrosNewForAgent)}
                onActiveItemUpdated={noop}
              />
            </ViewContainer>
          </ViewStack>
        )}
        <ViewStack>
          <AutomationsRouter />
        </ViewStack>
      </Grid>
    </ThemeProvider>
  );
};

export default withRememberLastRoute(Automations, "/automations");
